import React from "react";

const AccountsSelector = ({change}) => {
    return (
        <div className="row justify-content-center">
            <div className="col-md-6 col-sm-6">
                <div className="separator text-left" style={{cursor: "pointer"}}
                     onClick={() => change.callback({state: true, componentType: "register", refId: "courier"})}>
                    <div className="row">
                        <div className="col-2">
                        </div>
                        <div className="col-8">
                            <h5 className="header-text">Sign up as a courier business</h5>
                        </div>
                        <div className="col-2">
                            <i className="fas fa-chevron-right"/>
                        </div>
                    </div>
                </div>
                <hr/>
                <div className="separator text-left" style={{cursor: "pointer"}}
                     onClick={() => change.callback({state: true, componentType: "register", refId: "user"})}>
                    <div className="row">
                        <div className="col-2">
                        </div>
                        <div className="col-8">
                            <h5 className="header-text">Sign up to send a package</h5>
                        </div>
                        <div className="col-2">
                            <i className="fas fa-chevron-right"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccountsSelector;
